import apiClient from '../apiClient';
import { DELETE_COUNTRY_URL } from '../apiUrl';

const deleteCountryApi = Id => {
  return apiClient.delete(DELETE_COUNTRY_URL(Id));
};

export default deleteCountryApi;
